module.exports = __webpack_public_path__ + "img/ics_f_trash.60488e69.svg";